import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "next-themes";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Dashboard from "@/pages/Dashboard";
import Learn from "@/pages/Learn";
import Quiz from "@/pages/Quiz";
import Daily from "@/pages/Daily";
import Flashcards from "@/pages/Flashcards";
import DeckView from "@/pages/DeckView";
import { HistoryList, AttemptDetail } from "@/pages/History";
import Profile from "@/pages/Profile";
import Interview from "@/pages/Interview";
import Leaderboard from "@/pages/Leaderboard";
import Badges from "@/pages/Badges";
import Messages from "@/pages/Messages";
import Jobs from "@/pages/Jobs";
import Talent from "@/pages/Talent";
import CompanyPublic from "@/pages/CompanyPublic";
import EmployerRegister from "@/pages/EmployerRegister";
import EmployerDashboard from "@/pages/EmployerDashboard";
import BadgePublic from "@/pages/BadgePublic";
import LearnerPublic from "@/pages/LearnerPublic";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import Policy from "@/pages/Policy";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem storageKey="learnai-theme" disableTransitionOnChange>
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/badge/:id" element={<BadgePublic />} />
            <Route path="/learner/:handle" element={<LearnerPublic />} />
            <Route path="/talent" element={<Talent />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/legal/:slug" element={<Policy />} />
            <Route path="/company/:slug" element={<CompanyPublic />} />
            <Route path="/employer/register" element={<EmployerRegister />} />
            <Route path="/employer" element={<ProtectedRoute employerOnly><EmployerDashboard /></ProtectedRoute>} />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/daily" element={<Daily />} />
              <Route path="/flashcards" element={<Flashcards />} />
              <Route path="/flashcards/:id" element={<DeckView />} />
              <Route path="/history" element={<HistoryList />} />
              <Route path="/history/:id" element={<AttemptDetail />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/interview" element={<Interview />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/badges" element={<Badges />} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
    </ThemeProvider>
  );
}

export default App;
